import classifications from './classifications';
import items from './items';

export default {
  classifications,
  items
}
